import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getPropertiesRpc } from '../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/PropertyConfigService';
import { enrichCompanyRpc } from '../../../../__generated__/chirp/com/hubspot/enrichment/applications/rpc/CustomEnrichmentService';
import { COMPANY_TYPE_ID } from '../../../constants';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchSmartProperties = async () => {
  const companySmartPropertiesResponse = await rpcClient.call(getPropertiesRpc, {
    request: {
      objectType: COMPANY_TYPE_ID
    }
  });
  return getSmartProperties(companySmartPropertiesResponse.properties);
};
function getSmartProperties(properties) {
  return properties.map(property => {
    return {
      propertyName: property.propertyName,
      label: property.propertyLabel,
      objectType: property.objectTypeId,
      enrichmentQuestion: property.config.promptQuestion
    };
  });
}
export function runSmartProperties(context) {
  return rpcClient.call(enrichCompanyRpc, {
    request: {
      objectId: Number(context.objectId),
      propertyNames: context.selectedProperties,
      triggerType: 'MANUAL_APPLY'
    }
  });
}